import { appLayout } from '#app/init_app_layout.svelte.ts'
import { addRoutes } from '#app/lib/router'
import { commands, reqres } from '#app/radio'
import type { TransactionId } from '#server/types/transaction'
import { getRefreshedTransactions } from './lib/get_transactions.ts'

export default {
  initialize () {
    addRoutes({
      '/transactions(/)': 'showTransactions',
      '/transactions/:id(/)': 'showTransaction',
    }, controller)

    commands.setHandlers({
      'show:transactions': controller.showTransactions,
      'show:transaction': controller.showTransaction,
    })
  },
}

const controller = {
  async showTransactions () {
    if (reqres.request('require:loggedIn', 'transactions')) {
      await showTransactionsLayout()
    }
  },

  async showTransaction (id: string) {
    if (reqres.request('require:loggedIn', `transactions/${id}`)) {
      await showTransactionsLayout(id)
    }
  },
} as const

async function showTransactionsLayout (selectedTransactionId?: TransactionId) {
  const transactions = await getRefreshedTransactions()
  const { default: TransactionsLayout } = await import('./components/transactions_layout.svelte')
  let selectedTransaction
  if (selectedTransactionId) {
    selectedTransaction = transactions.find(transaction => transaction._id === selectedTransactionId)
  }
  appLayout.showChildComponent('main', TransactionsLayout, {
    props: {
      transactions,
      selectedTransaction,
    },
  })
}

export async function showTransaction (transactionId: TransactionId) {
  return showTransactionsLayout(transactionId)
}
